export const GuessLikeConfig = {
    //label 前端展示 value后端传递 mark 1 hot
    questionTxtList:[{
        label:"如何查我的求职进度？",
        value:"求职进度？",
    },{
        label:"总接到骚扰电话怎么办？",
        value:"骚扰电话",
    },{
        label:"了解会员权益,快速找工作",
        value:"了解会员权益,快速找工作",
        mark:"hot-mark"
    }],
    //label 前端展示 value后端传递 
    shortcutCardList:[{
        label:"适合我的职位",
        subtitle:"根据您的意向推荐",
        value:"适合我的职位",
        style:"style-purple"
    },  
    {
        label:"求职知识课堂",
        subtitle:"提高职场竞争力",
        value:"求职知识课堂",
        //mark:"new-mark",
        style:"style-blue"
    },{
        label:"小聘使用指南",
        subtitle:"常见功能介绍",
        value:"小聘使用指南",
        style:"style-yellow"
    }]
}